/**
*
* AccountUnPaid
*
*/

import React, { Component } from "react";
import styled from "styled-components";
import dataProvider from "utils/dataProvider";
import { Table, Button, Col, Row, DatePicker, Input } from "antd";
import dayjs from "dayjs";
// import styles from './AccountUnPaid.module.css'
// import PropTypes from 'prop-types'
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import "dayjs/locale/th";
import { Link } from "react-router-dom";

dayjs.extend(isSameOrAfter);

const { RangePicker } = DatePicker;

const { Search } = Input;

const PAGE_SIZE = 20;

const Container = styled.div`

`;
class AccountUnPaid extends Component { // eslint-disable-line
  state = {
    orders: [],
    orderCount: 0,
    startTime: null,
    endTime: null,
    search: null,
    currentPage: 1,
    user: null,
  }

  provider = dataProvider()

  componentDidMount() {
    this.fetchOrder();
    this.getUser();
  }


  getUser = async () => {
    try {
      const { id } = this.props.match.params;
      if (!id) {
        this.props.history.push("/404");
      }
      const user = await this.provider.fetch.get(`/myusers/${id}`, {}, { noCache: true });
      if (!user.emailVerified) {
        this.props.history.push(`/admin/users/validate/${user.id}`);
      }
      this.setState({ user });
    } catch (error) {
      this.props.history.push("/404");
    }
  }

  fetchOrder = async () => {
    const { id } = this.props.match.params;
    const body = {
      filter: {
        where: {
          myusersId: id
        },
        include: ["myusers"],
        order: "createdAt ASC",
        limit: PAGE_SIZE,
        skip: (this.state.currentPage - 1) * PAGE_SIZE,
      }
    };
    if (this.state.startTime && this.state.endTime) {
      body.filter.where.createdAt = {
        between: [this.state.startTime, this.state.endTime]
      };
    }
    if (this.state.search) {
      body.filter.where.orderCode = {
        like: `%${this.state.search}%`
      };
    }
    const orders = await this.provider.fetch.get("/orders", body, { noCache: true });
    const orderCount = await this.provider.fetch.get("/orders/count", { where: body.filter.where });
    this.setState({ orders, orderCount: orderCount.count });
  }

  onChangeDateFilter = (time) => {
    const [time1, time2] = time;
    const startTime = dayjs(time1).startOf("day");
    const endTime = dayjs(time2).endOf("day");
    this.setState({ startTime: new Date(startTime), endTime: new Date(endTime) }, () => this.fetchOrder());
  }

  handleChangePage = (page) => {
    this.setState({ currentPage: page }, () => this.fetchOrder());
  }

  handleSearch = (search) => {
    this.setState({ search }, () => this.fetchOrder());
  }

  render() {
    const columns = [
      {
        title: "เลข Order",
        dataIndex: "orderCode",
        key: "orderCode",
      },
      {
        title: "ร้าน",
        dataIndex: "myusers.shop_name",
        key: "myusers.shop_name",
      },
      {
        title: "เบอร์ติดต่อ",
        dataIndex: "myusers.mobile",
        key: "myusers.mobile",
      },
      {
        title: "ยอดรวม",
        key: "amount",
        dataIndex: "amount",
        render: (text, record) => (
          <span>{record.amount} บาท</span>
        )
      },
      {
        title: "วันที่สั่งสินค้า",
        dataIndex: "createdAt",
        key: "create",
        render: (create) => (
          <span>{`${dayjs(create).locale("th").format("YYYY-MMM-DD HH:mm น.")}`}</span>
        )
      },
      {
        title: "Action",
        key: "action",
        render: (text, record) => (
          <Link to={`/admin/orders/payment-status/${record.id}`}>
            ดูข้อมูล
          </Link>
        )
      }
    ];
    return (
      <Container>
        <h1 style={{ fontSize: 26 }}>Order ทั้งหมดของร้าน {this.state.user?.shop_name}</h1>
        <h1 style={{ fontSize: 20 }}>โดยคุณ {this.state.user?.full_name} เบอร์ติดต่อ {this.state.user?.phone}</h1>
        <Row type="flex" style={{ justifyContent: "space-between", marginBottom: 30 }}>
          <Col>
            <Search
              onSearch={this.handleSearch}
            />
          </Col>
          <Col>
            <RangePicker onChange={this.onChangeDateFilter} />
            <Button onClick={() => this.fetchOrder(dayjs().startOf("day"), dayjs().endOf("day"))}>เฉพาะวันนี้</Button>
            <Button onClick={() => this.fetchOrder()}>ดูทั้งหมด</Button>
          </Col>
        </Row>

        <Table
          columns={columns}
          dataSource={this.state.orders}
          rowKey={record => record.id}
          pagination={{
            position: "bottom",
            total: this.state.orderCount,
            pageSize: PAGE_SIZE,
            onChange: this.handleChangePage,
            current: this.state.currentPage
          }}
          scroll={{ x: 1000 }}
        />
      </Container>
    );
  }
}

AccountUnPaid.propTypes = {

};

AccountUnPaid.defaultProps = {

};
export default AccountUnPaid;
